import React, {useState} from 'react'
import jsPDF from 'jspdf';
import ModalPDF from '../Components/Alertas/ModalPDF';
import { Button, IconButton, Tooltip } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import AlertaSistema from '../Components/Alertas/AlertaSistema';

//Funcion para calcular la distancia entre dos puntos
function distancia(p1,p2) {
  const x = p1.x - p2.x
  const y = p1.y - p2.y

  return Math.sqrt(x * x + y * y)
}


const ExportarPDF = (props) => {

  const {
      stageRef, 
      window,
      setStageX, 
      setStageY, 
      setStageScale, 
      stageScale, 
      stageX, 
      stageY,
      nodos,
      setStageWidth,
      setStageHeight
  }  = props;
  const [nombreArchivo, setNombreArchivo] = useState('Archivo')
  const [abrirModal, setAbrirModal] = useState(false);
  
  const handleClose = (event) => {
    event.stopPropagation();
    setAbrirModal(false)
  };

  const exportData = () =>{
    setAbrirModal(false);
    const uri = stageRef.current.toDataURL();
    // we also can save uri as file
    // but in the demo on Konva website it will not work
    // because of iframe restrictions
    // but feel free to use it in your apps:
    // downloadURI(uri, 'stage.png');
    const height = window.innerWidth/3.779528;
    const width = window.innerHeight/3.779528;
    
    const pdf = new jsPDF('p', 'mm', [height, height]);
    pdf.addImage(uri, 'PNG', 1, 1, height, width);
    pdf.save(nombreArchivo+'.pdf'); 
  }

  const exportarStage = () =>{

    let minimoX = nodos[0].x;
        let minimoY = nodos[0].y;

        let maximoX = nodos[0].x;
        let maximoY = nodos[0].y;

        let bigW = nodos[0].width
        let bigH = nodos[0].height

        let maximoImgW = 0;
        let maximoImgH = 0;
        
        nodos.forEach((nodo) => {
          if(nodo.tieneImagen){
            if(nodo.imgWidth > maximoImgW){
                maximoImgW = nodo.imgWidth
            }
            if(nodo.imgHeight > maximoImgH){
                maximoImgH = nodo.imgHeight
            }
          }
          
          if(nodo.width > bigW){
              bigW = nodo.width
          }
          if(nodo.height > bigH){
              bigH = nodo.height
          }
          if(nodo.x-nodo.imgWidth < minimoX){
              minimoX = nodo.x-nodo.imgWidth
          }
          if(nodo.x+nodo.imgWidth > maximoX){
              maximoX = nodo.x+nodo.imgWidth
          }
          if(nodo.y-nodo.imgHeight < minimoY){
              minimoY = nodo.y-nodo.imgHeight
          }
          if(nodo.y > maximoY){
              maximoY = nodo.y
          }
        });
        
        
      //Punto arriba izq
        let p1 = {
          x: minimoX,
          y: minimoY
      }
      //Punto arriba derecha
      let p2 = {
          x: maximoX,
          y: minimoY
      }
      //Punto abajo derecha
      let p3 = {
          x: minimoX,
          y: maximoY
      }
      //Punto abajo izquierda
      let p4 = {
          x: maximoX,
          y: maximoY
      }

    setAbrirModal(false);
    let pdf = new jsPDF('l', 'px', 'a4');
    
    let width = pdf.internal.pageSize.getWidth();
    let height = pdf.internal.pageSize.getHeight();

    pdf.addImage(
      stageRef.current.toDataURL({ 
        x: minimoX+stageRef.current.attrs.x,
        y: minimoY+stageRef.current.attrs.y,
        width: Math.round(distancia(p1, p2)+bigW),
        height: Math.round(distancia(p1, p3)+bigH),
        pixelRatio: 2
      }),
      0,
      0,
      width,
      height,
    );

    pdf.save(nombreArchivo+'.pdf');
  }

  return (
    <>
      {abrirModal&& (
        <ModalPDF
          abrirModal={abrirModal}
          setAbrirModal={setAbrirModal}
          handleClose={handleClose}
          exportData={exportarStage}
          setNombreArchivo={setNombreArchivo}
        />
      )}
      <Tooltip title='Exportar como PDF'>
        <Button onClick={()=>{
            setAbrirModal(true) 
            setStageScale(1)
            setStageX(0)
            setStageY(0)
          }} type='submit' variant="outlined">
          <PictureAsPdfIcon/>
        </Button>
      </Tooltip>
    </>
  )
}

export default ExportarPDF